var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Dashboard widget factories — chartPanel.
 */
import { registerDashboard, createDashboardFromJSON } from '../registryCore';
import { createWidgetGroup, num, setParts, setState, str, } from '../helpers';
import { getActiveDashboard } from '../theme';
/** Framed chart with title bar — embed any registered chart type. */
registerDashboard('chartPanel', function (props, app) {
    var chartType = str(props, 'chartType', 'lineChart');
    var title = str(props, 'title', chartType);
    var width = num(props, 'width', 320);
    var height = num(props, 'height', 200);
    var pad = 8;
    var headerH = 26;
    var innerW = Math.max(40, width - pad * 2);
    var innerH = Math.max(32, height - headerH - pad);
    var group = createWidgetGroup(app, 'chartPanel', props);
    group.add(app.rect({
        width: width,
        height: height,
        fill: getActiveDashboard().chartBg,
        stroke: getActiveDashboard().panelStroke,
        strokeWidth: 1,
        cornerRadius: 8,
        listening: false,
    }), app.text({
        text: title,
        x: pad,
        y: 6,
        fontSize: 12,
        fontWeight: 'bold',
        fill: getActiveDashboard().text,
        listening: false,
    }));
    if (props.maximizable !== false) {
        group.add(app.text({
            text: '⤢',
            x: width - 22,
            y: 5,
            fontSize: 14,
            fill: getActiveDashboard().textMuted,
            listening: true,
            metadata: { chartPanelAction: 'maximize' },
        }));
    }
    var chartProps = __assign({}, props);
    delete chartProps.chartType;
    delete chartProps.title;
    delete chartProps.width;
    delete chartProps.height;
    delete chartProps.maximizable;
    var chart = createDashboardFromJSON(chartType, __assign(__assign({}, chartProps), { width: innerW, height: innerH, x: pad, y: headerH, responsive: props.responsive !== false, zoomEnabled: props.zoomEnabled !== false }), app);
    if (chart) {
        chart.x = pad;
        chart.y = headerH;
        group.add(chart);
        setParts(group, { chart: chart });
    }
    setState(group, { chartType: chartType, title: title, width: width, height: height, innerW: innerW, innerH: innerH });
    return group;
});
